export default {
  ios: `/v2/download_app/current_version`,
  index: `/v2/app_versions`
};
